export default QueryString;

/** @ngInject */
function QueryString() {
  var vm = this;
  var r20 = /%20/g;

  vm.stringify = stringify;

  function stringify(a) {
    var prefix,
      s = [],
      add = function (key, value) {
        s[s.length] =
          encodeURIComponent(key) + '=' +
          encodeURIComponent([null, undefined, NaN].indexOf(value) !== -1 ? '' : value);
      };

    for (prefix in a) {
      buildParams(prefix, a[prefix], add);
    }

    return s.join('&').replace(r20, '+');
  }

  function buildParams(prefix, obj, add) {
    if (Array.isArray(obj)) {
      buildArrayParams(prefix, obj, add);
    } else if (obj && typeof obj === 'object') {
      buildObjectParams(prefix, obj, add);
    } else {
      add(prefix, obj);
    }
  }

  function buildArrayParams(prefix, obj, add) {
    for (var i in obj) {
      var v = obj[i];
      buildParams(prefix + '[' + ( typeof v === 'object' ? i : '' ) + ']', v, add);
    }
  }

  function buildObjectParams(prefix, obj, add) {
    for (var name in obj) {
      buildParams(prefix + '[' + name + ']', obj[name], add);
    }
  }
}



/** WEBPACK FOOTER **
 ** ../~/tslint-loader!./common/services/query-string.service.ts
 **/